import React, { FunctionComponent } from "react";

import { Language } from "../../../../../i18n/useLanguage";
import {
  IncludedOptionalLineItem,
  MandatoryLineItem,
  OptionalLineItem,
} from "../../../../../stores/slices/cartSlice";

export const LineItemName: FunctionComponent<{
  item: IncludedOptionalLineItem | MandatoryLineItem | OptionalLineItem;
  language: Language;
}> = ({ item, language }) => {
  const set = new Set([
    item.title[language] || item.title["en"],
    item.description[language] || item.description["en"],
  ]);
  const [name, description] = [...set]
    .map((item) => item.trim())
    .filter(Boolean);

  return (
    <>
      {name} {description && <div className="font-light">{description}</div>}
    </>
  );
};
